import React, { Component } from "react";
import snippet1 from './data-forumsnippet1.js';

import './whatson.css';

class ForumSnippet1 extends Component {

  render() {
    return (
        <div className="snippet1">
        {snippet1.map(item =>
            <a href={item.url}>
        <div key={item.objectID}> 
        <h1>{item.title}</h1>
        <p><a href={item.url}>{item.data}</a></p>
        <br></br>
        <a href={item.url}><img src={item.imgurl} alt="snippet1"/></a>
        </div>
        </a>
            )}
        </div>
        );
}
}
  

export default ForumSnippet1;



// WEBPACK FOOTER //
// ./src/ForumSnippet1.js